import { IconButton, Tooltip, useTheme } from '@mui/material';
import { Save2 } from 'iconsax-react';
import type { ReactElement } from 'react';

type SaveButtonProps = {
  onSave: () => void;
};

export const SaveButton = ({ onSave }: SaveButtonProps): ReactElement => {
  const theme = useTheme();
  return (
    <Tooltip title='Save Filters'>
      <IconButton onClick={onSave}>
        <Save2 variant='TwoTone' color={theme.palette.SlabIndigo['700']} />
      </IconButton>
    </Tooltip>
  );
};
